import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import './index.scss'
import { ReactComponent as Reverse } from '../../../../assets/tariffs/reverse.svg'
import { ReactComponent as Close } from '../../../../assets/tariffs/close.svg'
// import { ReactComponent as Logo } from '../../../../assets/logo.svg'
import loader from '../../../../assets/loaders/np-preloader1.gif'
import TariffsSelect from '../TariffsSelect'
import { useEffect, useState } from 'react'
import { CountriesStore } from '../../career/CoopPop'
import GlobalState from '../../../../stores/GlobalState'
import classNames from 'classnames'
import TariffsResult from '../TariffsResult'
import { useLocation } from 'react-router'
const Tariffs = observer(() => {
  const [isLoad, setLoad] = useState(false)
  const content = ContentState.tariffs
  const { pathname } = useLocation()
  const [state, setState] = useState({
    from: {
      flag: '',
      country: '',
    },
    to: {
      flag: '',
      country: '',
    },
    type: content?.types[0] || '',
    factWeight: '',
    width: '',
    height: '',
    length: '',
    weight: '',
  })

  const [errors, setErrors] = useState({
    from: false,
    to: false,
    type: false,
    factWeight: false,
    width: false,
    height: false,
    length: false,
  })

  const [result, setResult] = useState<any>(null)

  const clear = () => {
    setState({
      ...state,
      from: {
        flag: '',
        country: '',
      },
      to: {
        flag: '',
        country: '',
      },
      type: content.types[0] || '',
      factWeight: '',
      width: '',
      height: '',
      length: '',
      weight: '',
    })

    setResult(null)

    setErrors({
      ...errors,
      from: false,
      to: false,
      type: false,
      factWeight: false,
      width: false,
      height: false,
      length: false,
    })
  }
  useEffect(() => {
    if (CountriesStore.list) {
      let ukraine: any = null,
        gb: any = null
      if (GlobalState.currentLocale.lang.includes('En')) {
        ukraine = CountriesStore.list.en.find(
          (e: any) => e.country == 'Ukraine',
        )
        gb = CountriesStore.list.en.find(
          (e: any) => e.country == 'United States',
        )
      }

      if (GlobalState.currentLocale.lang.includes('ру')) {
        ukraine = CountriesStore.list.ru.find(
          (e: any) => e.country == 'Украина',
        )

        gb = CountriesStore.list.ru.find(
          (e: any) => e.country == 'Соединенные Штаты',
        )
      }

      if (GlobalState.currentLocale.lang.includes('Укр')) {
        ukraine = CountriesStore.list.uk.find(
          (e: any) => e.country == 'Україна',
        )

        gb = CountriesStore.list.uk.find(
          (e: any) => e.country == 'Сполучені Штати',
        )
      }

      setState({ ...state, from: ukraine, to: gb })
    }
  }, [CountriesStore.list, GlobalState.currentLocale])

  const calc = async () => {
    const errs = {
      from: state.from.country.length > 0 ? false : true,
      to: state.to.country.length > 0 ? false : true,
      factWeight: state.factWeight.length > 0 ? false : true,
      width: state.width.length > 0 ? false : true,
      height: state.height.length > 0 ? false : true,
      length: state.length.length > 0 ? false : true,
      type: state.type.length > 0 ? false : true,
    }

    setErrors({
      ...errs,
    })

    const langList = GlobalState.currentLocale.lang.includes('Укр')
      ? 'uk'
      : GlobalState.currentLocale.lang.includes('En')
      ? 'en'
      : 'ru'

    const list = CountriesStore.list[langList]

    if (
      state.factWeight.length &&
      state.from.country.length &&
      state.height.length &&
      state.width.length &&
      state.weight.length &&
      state.type.length
    ) {
      const from = list.find((c: any) => c.country == state.from.country)
      const to = list.find((c: any) => c.country == state.to.country)

      const fromInUKR = CountriesStore.list.uk?.find(
        (c: any) => c.code == from.code,
      )
      const toInUKR = CountriesStore.list.uk?.find(
        (c: any) => c.code == to.code,
      )

      const cargotype = ['Вантаж', 'Cargo']
      const formData = new FormData()
      formData.append('pickup_country', fromInUKR?.country)
      formData.append('destination_country', toInUKR?.country)
      formData.append('width', state.width)
      formData.append('weight', state.factWeight)
      formData.append('length', state.length)
      formData.append('height', state.height)
      formData.append('type', cargotype.includes(state.type)?'Вантаж':"Документи")
      formData.append(
        'page_num',
        window.location.href.includes('/for-you/') ? '1' : '2',
      )
      formData.append('lang', GlobalState.currentLocale.lang)
      formData.append('status', 'calc')
      setResult(null)
      setLoad(true)

      const lang = pathname.includes('/en/')
        ? '/en/'
        : pathname.includes('/ru/')
        ? '/ru/'
        : '/'

      fetch(GlobalState.domain, {
        body: formData,
        method: 'POST',
      })
        .then((request) => request.json())
        .then((response) => {
          if (!response) {
            window.location.href = lang + 'error-api'
            return
          }

          if (response.length) {
            ;(window as any).dataLayer = (window as any).dataLayer || []
            ;(window as any).dataLayer.push({ event: 'calculate' })
          }
          setResult(response)
        })
        .catch((e) => {
          window.location.href = lang + 'error-api'
        })
    }
  }

  const reverse = () => {
    const from = state.from,
      to = state.to
    setState({ ...state, to: from, from: to })
  }

  const mulValue = !pathname.includes('/for-you/') ? 5000 : 4000

  useEffect(() => {
    const weight = (
      (+state.length * +state.width * +state.height) /
      mulValue
    ).toFixed(2)
    setState({ ...state, weight: weight.toString() })
  }, [state.factWeight, state.height, state.width, state.length])

  const [width, setWidth] = useState(window.innerWidth)

  useEffect(() => {
    window.addEventListener('resize', () => setWidth(window.innerWidth))
  }, [])

  useEffect(() => {
    if (result) {
      const form = document.querySelector('.tariffs__calc')
      if (!form) return
      const top = (form as HTMLElement).nextElementSibling!.getBoundingClientRect()
          .top,
        bodyTop = document.body.getBoundingClientRect().top
      const offset = top - bodyTop - 50

      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      })
    }
  }, [result])

  useEffect(() => {
    if (result) {
      setLoad(false)
    }
  }, [result])

  let list = GlobalState.currentLocale.lang.includes('En')
    ? CountriesStore.list?.en
    : GlobalState.currentLocale.lang.includes('ру')
    ? CountriesStore.list?.ru
    : CountriesStore.list?.uk

  if (list) {
    list = JSON.parse(JSON.stringify(list))
    list = list.sort((a: any, b: any) =>
      a.country.trim().localeCompare(b.country.trim()),
    )
  }

  return (
    <section className="tariffs">
      <div className={classNames('tariffs__calc')}>
        <div className="tariffs__title">{content?.title}</div>
        <div
          className="tariffs__text"
          dangerouslySetInnerHTML={{ __html: content?.text }}
        ></div>
        <div className="tariffs__calc-cont">
          <div className={classNames('tariffs__loader', isLoad && 'loader')}>
            <img src={loader} />
          </div>
          <div className="tariffs__table">
            <div className="tariffs__table-row">
              <div className="tariffs__table-label">{content?.route}</div>
              <div className="tariffs__table-subrow">
                <div className="tariffs__table-col">
                  <div className="tariffs__table-sublabel">{content?.from}</div>
                  <TariffsSelect
                    dt={list || []}
                    showInput
                    isError={errors.from}
                    isFlag={true}
                    defaultValue={content?.from}
                    value={state.from}
                    getValue={(value) => setState({ ...state, from: value })}
                  />
                </div>
                <div className="tariffs__reverse-cont">
                  <div className="tariffs__reverse" onClick={reverse}>
                    <Reverse />
                  </div>
                  {width <= 760 && (
                    <div className="tariffs__tip tip-top">
                      ?
                      <div className="tariffs__tip-text tip-top">
                        {content?.routeTip}
                      </div>
                    </div>
                  )}
                </div>

                <div className="tariffs__table-col mt24">
                  <div className="tariffs__table-sublabel">{content?.to}</div>
                  <TariffsSelect
                    dt={list || []}
                    isError={errors.to}
                    showInput
                    isFlag={true}
                    defaultValue={content?.to}
                    value={state.to}
                    getValue={(value) => setState({ ...state, to: value })}
                  />
                </div>
                {width > 760 && (
                  <div className="tariffs__tip tip-top">
                    ?
                    <div className="tariffs__tip-text tip-top">
                      {content?.routeTip}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="tariffs__table-row">
              <div className="tariffs__table-label">{content?.type}</div>
              <div className="tariffs__table-subrow row-display">
                <TariffsSelect
                  isError={errors.type}
                  dt={content?.types}
                  isFlag={false}
                  defaultValue={state.type}
                  value={state.type}
                  getValue={(value) => setState({ ...state, type: value })}
                />
                <div className="tariffs__tip">
                  ?
                  <div
                    className={classNames(
                      'tariffs__tip-text',
                      width <= 760 && 'tip-top',
                    )}
                  >
                    {content?.typeTip}
                  </div>
                </div>
              </div>
            </div>
            <div className="tariffs__table-row">
              <div className="tariffs__table-label">{content?.params}</div>
              <div className="tariffs__table-subrow row-display">
                <div className="tariffs__table-col mr26">
                  <div className="tariffs__table-sublabel">
                    {content?.factWeight}
                  </div>
                  <div className="tariffs__table-inline">
                    <input
                      type="number"
                      onChange={(e) =>
                        setState({ ...state, factWeight: e.target.value })
                      }
                      className={classNames(
                        'input',
                        errors.factWeight && 'error-input',
                      )}
                      value={state.factWeight}
                    />
                    <div className="tariffs__table-unit">
                      {content?.weightUnit}
                    </div>
                    <div className="tariffs__tip">
                      ?
                      <div className="tariffs__tip-text tip-top">
                        {content?.factWeightTip}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tariffs__table-col">
                  <div className="tariffs__table-sublabel">
                    {content?.width}
                  </div>
                  <div className="tariffs__table-inline">
                    <input
                      type="number"
                      onChange={(e) =>
                        setState({ ...state, width: e.target.value })
                      }
                      className={classNames(
                        'input',
                        errors.width && 'error-input',
                      )}
                      value={state.width}
                    />
                    <div className="tariffs__table-divider">x</div>
                  </div>
                </div>
                <div className="tariffs__table-col">
                  <div className="tariffs__table-sublabel">
                    {content?.height}
                  </div>
                  <div className="tariffs__table-inline">
                    <input
                      type="number"
                      onChange={(e) =>
                        setState({ ...state, height: e.target.value })
                      }
                      value={state.height}
                      className={classNames(
                        'input',
                        errors.height && 'error-input',
                      )}
                    />
                    <div className="tariffs__table-divider">x</div>
                  </div>
                </div>
                <div className="tariffs__table-col mr26 display-inline">
                  <div className="tariffs__table-sublabel">
                    {content?.length}
                  </div>
                  <div className="tariffs__table-inline">
                    <input
                      type="number"
                      onChange={(e) =>
                        setState({ ...state, length: e.target.value })
                      }
                      value={state.length}
                      className={classNames(
                        'input',
                        errors.length && 'error-input',
                      )}
                    />
                    <div className="tariffs__table-unit">
                      {content?.lengthUnit}
                    </div>
                    <div className="tariffs__tip">
                      ?
                      <div className="tariffs__tip-text tip-top">
                        {content?.lengthTip}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tariffs__table-col">
                  <div className="tariffs__table-sublabel">
                    {content?.weight}
                  </div>
                  <div className="tariffs__table-inline">
                    <input
                      type="number"
                      disabled
                      value={state.weight}
                      className="input"
                    />
                    <div className="tariffs__table-unit">
                      {content?.weightUnit}
                    </div>
                    <div className="tariffs__tip">
                      ?
                      <div className="tariffs__tip-text tip-top">
                        {content?.weightTip}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tariffs__bottom">
            <div className="button black" onClick={calc}>
              {content?.buttonTitle}
            </div>
            <div className="tariffs__clear" onClick={clear}>
              <Close /> <span>{content?.clear}</span>
            </div>
          </div>
        </div>
      </div>
      {result && <TariffsResult list={result} />}
    </section>
  )
})

export default Tariffs
